/** The bounds the API enforces on a discount code, shared so that the admin portal can
 * apply the same rules before it submits one */
export const DISCOUNT_CODE_MIN_LENGTH = 4;
export const DISCOUNT_CODE_MAX_LENGTH = 40;

/** The query parameter a discount code travels in. Read by the middleware, the sign-up
 * flows and the canonical-URL builder. */
export const DISCOUNT_CODE_QUERY_PARAM = "discount_code";

export const CREDIT_REASON_OPTIONS_NO_EMPTY = [
  "ambassador_error",
  "breeder_error",
  "ds_error",
  "quality_investigating",
  "quality_open packaging",
  "quality_defrosted",
  "quality_empty",
  "quality_foreign object",
  "quality_ice pack",
  "quality_broken",
  "quality_smell",
  "error_cx",
  "error_cp",
  "error_tech",
  "error_comms",
  "error_p&p",
  "marketing_research",
  "team_discount",
  "litter_return",
  "GWG_cat passed_away",
  "GWG_cat health",
  "GWG_not_eating",
  "GWG_review",
  "GWG_waived_delivery_fee",
  "GWG_unaware_frozen",
  "GWG_vulnerable_error_LTV_CP",
  "GWG_sub",
  "GWG_freezer",
  "Order cancelled pre cut-off",
  "review_prevention",
  "Testing_Team",
  "fresh_dpd_damaged",
  "fresh_dpd_delayed",
  "fresh_dpd_not_received",
  "fresh_dpd_incorrect_address",
  "fresh_dpd_other",
  "fresh_yodel_damaged",
  "fresh_yodel_delayed",
  "fresh_yodel_not_received",
  "fresh_yodel_incorrect_address",
  "fresh_yodel_other",
  "litter_dpd_damaged",
  "litter_dpd_delayed",
  "litter_dpd_not_received",
  "litter_dpd_incorrect_address",
  "litter_dpd_other",
  "litter_yodel_damaged",
  "litter_yodel_delayed",
  "litter_yodel_not_received",
  "litter_yodel_incorrect_address",
  "litter_yodel_other",
  "brand_and_community",
  "cx_surprise_and_delight",
] as const;

export type TCreditReason = typeof CREDIT_REASON_OPTIONS_NO_EMPTY[number];

export const CREDIT_REASON_OPTIONS_WITH_EMPTY = [
  "",
  ...CREDIT_REASON_OPTIONS_NO_EMPTY,
] as const;
